// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-21T22:01:02.300Z
// Property: Elevation (ID: 6767906449166432)
// Collections: 34 amenities, 3 floorplans (live), 20 photos, 52 POIs, 4 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166432",
  "property_external_id": "kmehzmb",
  "property_zillow_url": "https://www.zillow.com/apartments/flagstaff-az/elevation/5XrkSS/",
  "property_apartments_url": "https://www.apartments.com/elevation-luxury-apartments-flagstaff-az/kmehzmb/",
  "property_google_business_url": "https://www.google.com/maps/place/Elevation+Apartments/data=!4m2!3m1!1s0x0:0x6b141baf3597bc54?sa=X&ved=2ahUKEwjm2ZD54aeSAxXi5MkDHQdCK3UQ_BJ6BAgREAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "8878162707",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "96ELF",
  "property_status": null,
  "property_slug": "elevation",
  "property_name": "Elevation",
  "property_website_url": "https://www.elevationflagstaff.com/",
  "property_domain": "https://www.elevationflagstaff.com/",
  "property_address": "5000 North Mall Way",
  "property_full_address": "5000 N Mall Way, Flagstaff, AZ 86004",
  "property_address_1": "5000 N Mall Way",
  "property_address_2": null,
  "property_address_city": "Flagstaff",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "86004",
  "property_address_country": "US",
  "property_address_county": "Coconino County",
  "property_neighborhood_address": "Flagstaff",
  "property_address_latitude": "35.226736",
  "property_address_longitude": "-111.5770139",
  "property_email": null,
  "property_phone": "(928) 440-7692",
  "property_call_tracking_phone": "844-870-3770",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Elevation, where comfort meets style in Flagstaff, AZ. Choose from spacious one to three-bedroom floor plans, featuring gourmet island kitchens, vaulted ceilings, and pet-friendly amenities. Unwind in our heated pool, savor outdoor cooking, or enjoy scenic mountain views—your perfect home awaits! Explore availability today!",
  "property_long_description": "Welcome to Elevation, your ideal apartment community nestled in the scenic beauty of Flagstaff, AZ. Our thoughtfully designed floor plans offer one, two, and three-bedroom apartments tailored to fit a variety of lifestyles. Each home features an open-concept layout with elegant lighting, sleek modern cabinetry, and spacious closets for maximum comfort. Enjoy culinary delights in your island kitchen, and unwind on your private patio or balcony, where you can bask in the breathtaking mountain views.\n\nAt Elevation, we provide resort-style amenities to elevate your living experience. Gather with friends at our outdoor kitchen complete with a gas BBQ grill, or relax in our year-round heated pool and spa. Stay active in our state-of-the-art 24-hour fitness center with a dedicated spin and yoga studio. Your furry friends are welcome in our pet-friendly community, complete with a large pet park.\n\nConvenience meets luxury with included amenities such as Amazon Hub package lockers, assigned covered carports, and online rental payments. Our clubhouse offers complimentary coffee and Wi-Fi, perfect for hosting gatherings or simply enjoying peaceful downtime. Enjoy peace of mind with our on-site management and 24-hour emergency maintenance services.\n\nDiscover a community designed for your comfort and convenience at Elevation. With flexible leases, gated access, and the latest fiber optic internet property-wide, you won’t want to miss out on your new home! Find your new home today—browse our availability or schedule a tour to visit our community!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019f6b9a-c268-7380-8760-ffee7389ca48.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
    "public_id": "019f6b9a-c268-7380-8760-ffee7389ca48",
    "storage_key": "property/6767906449166432/019f6b9a-c268-7380-8760-ffee7389ca48.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166432/019ffc39-9137-720b-b400-2f7a07c5c2f8.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc39-9137-720b-b400-2f7a07c5c2f8",
    "storage_key": "property/6767906449166432/019ffc39-9137-720b-b400-2f7a07c5c2f8.m4v",
    "thumbnail_key": "property/6767906449166432/019ffc39-9137-720b-b400-2f7a07c5c2f8_thumb.webp",
    "size_bytes": 26942801,
    "classification": "Community",
    "title": "Elevation Apartment Homes | Luxury Living in Reno, NV",
    "description": "Discover your new home at Elevation Apartment Homes, offering spacious apartments and a vibrant community with resort-style amenities."
  },
  "property_total_units": "288",
  "property_year_built": "2013",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.875",
  "property_admin_fee": "500",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security Deposit\n$300 up to one months rent",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "600",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "55",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions apply.",
  "property_pet_policy_description": "We welcome cats and dogs. Breed restrictions apply. (Please call for details.)",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://elevationluxury.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amcelevation",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02ca-8848-7469-9394-65c522779468.webp",
  "property_primary_logo_media": {
    "alt_text": "Elevation Luxury Apartments logo",
    "public_id": "019d02ca-8848-7469-9394-65c522779468",
    "storage_key": "property/6767906449166432/019d02ca-8848-7469-9394-65c522779468.webp",
    "width": 349,
    "height": 95
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02ca-71df-72ed-bef1-c0da3023a01b.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02ca-71df-72ed-bef1-c0da3023a01b",
    "storage_key": "property/6767906449166432/019d02ca-71df-72ed-bef1-c0da3023a01b.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02ca-9ec7-775c-989e-33ad60149e8b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Elevation Luxury Apartments logo",
    "public_id": "019d02ca-9ec7-775c-989e-33ad60149e8b",
    "storage_key": "property/6767906449166432/019d02ca-9ec7-775c-989e-33ad60149e8b.webp",
    "width": 349,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02ca-8848-7469-9394-65c522779468.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Elevation Luxury Apartments logo",
    "public_id": "019d02ca-8848-7469-9394-65c522779468",
    "storage_key": "property/6767906449166432/019d02ca-8848-7469-9394-65c522779468.webp",
    "width": 349,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "755 - 1158",
  "property_sqft_min": "755",
  "property_sqft_max": "1158",
  "property_price_range": "$1879 - $2662",
  "property_price_min": "1879",
  "property_price_max": "2662",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/Elevation.Flagstaff/",
  "property_instagram_url": "https://www.instagram.com/elevationluxuryapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ52UiPqyOLYcRVLyXNa8bFGs",
  "property_youtube_url": "https://www.youtube.com/watch?t=290&v=3KFSs6EiFVE",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartment&find_loc=Flagstaff%2C+AZ",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Elevation",
  "property_home_romance_title": "Experience the Joy of Living in Your Ideal Home",
  "property_home_amenities_blurb": "At Elevation in Flagstaff, AZ, luxury and comfort converge. Choose from one to three-bedroom floor plans featuring open concept layouts and modern designs. With amenities like a year-round heated pool, fitness center, and a pet-friendly environment, you’re destined to thrive in this stunning mountainside oasis.",
  "property_home_floorplans_blurb": "Welcome to Elevation in Flagstaff, AZ, where modern living meets stunning mountain views. Choose from our thoughtfully designed one, two, and three-bedroom apartments, each tailored to your lifestyle. Navigate through our unique floor plans to find the perfect space that feels like home. Your new adventure starts here!",
  "property_home_gallery_blurb": "At Elevation in Flagstaff, AZ, life is an experience. Enjoy spacious one, two, and three-bedroom floor plans featuring modern touches like island kitchens and elegant lighting. With amenities like a year-round heated pool, outdoor kitchen, and a pet-friendly atmosphere, you’ll find the perfect blend of comfort and community. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Elevation, where your new home in Flagstaff, AZ seamlessly blends comfort and adventure. Nestled near cultural gems like the Museum of Northern Arizona and the astounding Walnut Canyon National Monument, enjoy easy access to education at Northern Arizona University. Dive into a lifestyle that celebrates the unique charm of the region!",
  "property_home_reviews_blurb": "At Elevation in Flagstaff, AZ, residents cherish their vibrant community, with one highlighting, “The breathtaking views and friendly atmosphere make it feel like home.” Immerse yourself in this spectacular setting—our welcoming environment and stunning surroundings are just a glimpse of what makes living here extraordinary! See what our residents have to say!",
  "property_neighborhood_blurb": "At Elevation in Flagstaff, AZ, vibrant living meets rich heritage. Nestled near the Museum of Northern Arizona and the stunning Walnut Canyon National Monument, our community bursts with adventure. Enjoy scenic parks, acclaimed libraries, and cultural gems just moments away. Dive into the heart of Flagstaff’s unique charm today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Elevation in Flagstaff, AZ, where modern living meets nature's tranquility. Enjoy our resort-style amenities, from a year-round heated pool and outdoor kitchen to an inviting clubhouse. With pet-friendly spaces, spacious layouts, and stunning mountain views, you'll find your perfect oasis for relaxation and connection.",
  "property_applynow_blurb": "At Elevation in Flagstaff, AZ, unique floor plans meet exceptional amenities, enhancing your lifestyle. Enjoy leisurely afternoons at the year-round heated pool, unwind in our spa, or savor outdoor meals at the BBQ grill. With spacious layouts, modern finishes, and breathtaking mountain views, your new home awaits. Lease online today!",
  "property_contactus_blurb": "At Elevation in vibrant Flagstaff, AZ, we offer thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Reach out to our leasing team today with any questions—you’re just a step away from making your ideal home a reality!",
  "property_faqs_blurb": "At Elevation in Flagstaff, AZ, we offer spacious one, two, and three-bedroom floor plans tailored to your lifestyle. Have questions? Our Frequently Asked Questions page is your go-to resource for insights about our community, ensuring you find the perfect fit for your needs. Start your journey with us today!",
  "property_floorplans_blurb": "At Elevation in Flagstaff, AZ, your ideal living space awaits. Choose from our thoughtfully designed one, two, or three-bedroom floor plans that blend comfort and style. Each layout caters to your unique lifestyle. Browse our available apartment homes today and begin crafting the life you've always envisioned.",
  "property_gallery_blurb": "At Elevation in Flagstaff, AZ, picture a vibrant lifestyle surrounded by stunning mountain views and modern comforts. From spacious one, two, and three-bedroom apartments featuring sleek cabinetry and open layouts, to resort-style amenities like a heated pool and outdoor kitchen, your dream home awaits. Experience community living at its finest!",
  "property_interactivemap_blurb": "At Elevation in Flagstaff, AZ, your ideal home awaits amid stunning mountain views. From spacious one to three-bedroom layouts featuring modern finishes and open-concept designs, to exceptional amenities like a heated pool, 24-hour fitness center, and pet-friendly park, enjoy a lifestyle that elevates everyday living. Use our interactive community map today!",
  "property_pets_blurb": "At Elevation in Flagstaff, AZ, find your perfect home amid stunning mountain vistas. Our pet-friendly community invites cats and dogs (breed restrictions apply) to join you in creating unforgettable memories. Experience modern living in a vibrant neighborhood, where adventure and relaxation seamlessly intertwine. Make Elevation your personal sanctuary today!",
  "property_referafriend_blurb": "At Elevation in Flagstaff, AZ, your perfect home awaits—whether it's a cozy one-bedroom or a spacious three-bedroom. Enjoy a vibrant community where great friends make great neighbors. Spread the joy of elevated living—refer a friend today and let them experience life at Elevation!",
  "property_residentaccess_blurb": "Welcome to Elevation in Flagstaff, AZ, where comfort meets convenience! Whether you need a cozy one-bedroom or a spacious three-bedroom, our varied floor plans cater to your lifestyle. Access your resident portal today for hassle-free rent payments and maintenance requests—your seamless living experience awaits!",
  "property_reviews_blurb": "At Elevation in beautiful Flagstaff, AZ, residents rave about their experience, stating it’s “a perfect blend of comfort and community.” With stunning views and vibrant amenities, our apartment community fosters a welcoming atmosphere. See what our residents have to say about living at our community!",
  "property_created_at": "1759782553133",
  "property_scheduletour_blurb": "Elevate your living experience in Flagstaff at Elevation, where spacious one, two, and three-bedroom floor plans await. Each home is thoughtfully designed to blend comfort and style. Don't just take our word for it—schedule a tour and hear firsthand what our residents love about their vibrant community!",
  "property_thankyou_blurb": "Thank you for reaching out to Elevation in Flagstaff, AZ! Our thoughtfully designed one, two, and three-bedroom floor plans offer the perfect blend of comfort and style. A team member will connect with you shortly to help you find your ideal home amidst the majestic backdrop of Flagstaff.",
  "property_virtualtours_blurb": "Step into Elevation, where Flagstaff's charm meets your ideal living space. Our thoughtfully designed one, two, and three-bedroom apartments reflect style and comfort. Embrace the beauty of community life—take a virtual tour to experience your new home today! Your next adventure awaits at Elevation!",
  "property_copyright": "2025 All Rights Reserved. Elevation",
  "property_seo_title_home": "Elevation |  Apartments in Flagstaff, AZ",
  "property_seo_description_home": "Experience elevated living at Elevation Luxury Apartments in Flagstaff, AZ. Enjoy scenic mountain views, and great amenities in East Flagstaff.",
  "property_seo_title_floorplans": "Floor Plans | Flagstaff, AZ Apartments for Rent",
  "property_seo_description_floorplans": "Explore studio, one-, two-, and three-bedroom floor plans at Elevation Luxury Apartments in Flagstaff, AZ. Find open layouts designed for comfort and style.",
  "property_seo_title_amenities": "Amenities | Pet-Friendly Apartments near Buffalo Park",
  "property_seo_description_amenities": "Enjoy premium amenities at Elevation Luxury Apartments in Flagstaff, AZ, including a pet park, community spaces, and modern apartment features.",
  "property_seo_title_gallery": "Gallery | Apartments near Buffalo Park",
  "property_seo_description_gallery": "View photos of Elevation Luxury Apartments in Flagstaff, AZ. Discover modern interiors, scenic Mount Elden views, and thoughtfully designed community amenities.",
  "property_seo_title_virtualtours": "Virtual Tour | Pet-Friendly Apartments in Flagstaff, AZ",
  "property_seo_description_virtualtours": "Take a virtual tour of Elevation Luxury Apartments in Flagstaff, AZ. Explore modern interiors, open floor plans, and stylish community amenities from anywhere.",
  "property_seo_title_interactivemap": "Interactive Map | Apartments for Rent in Flagstaff, AZ",
  "property_seo_description_interactivemap": "Discover your perfect home at Elevation in Flagstaff! Explore spacious layouts and scenic views with our interactive map. Your ideal space awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments Near Flagstaff, AZ",
  "property_seo_description_neighborhood": "Discover life in East Flagstaff at Elevation Luxury Apartments. Enjoy easy access to Flagstaff Mall, Route 66 shopping, outdoor recreation, and local dining.",
  "property_seo_title_contact": "Contact Us | Apartments in Flagstaff, AZ",
  "property_seo_description_contact": "Contact the leasing team at Elevation Luxury Apartments in Flagstaff, AZ. We’re here to answer questions and help you find your perfect apartment home.",
  "property_seo_title_faqs": "FAQs | Apartments in Flagstaff, AZ",
  "property_seo_description_faqs": "Find answers to frequently asked questions about Elevation Luxury Apartments in Flagstaff, AZ, including leasing, amenities, pet policies, and more.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Flagstaff, AZ",
  "property_seo_description_reviews": "Experience life at Elevation in Flagstaff, AZ, where scenic mountain views meet luxury amenities. See what our residents love about their vibrant community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Flagstaff, AZ",
  "property_seo_description_applynow": "Elevate your living in Flagstaff, AZ! Enjoy stunning views, pet-friendly amenities, and stylish layouts. Apply now for your new home!",
  "property_seo_title_residentaccess": "Apartments for Rent in Flagstaff, AZ",
  "property_seo_description_residentaccess": "Elevate your living at Elevation in Flagstaff, AZ. Log in to your resident portal for easy rent payment, maintenance requests, and community updates!",
  "property_seo_title_referafriend": "Refer A Friend | Elevation",
  "property_seo_description_referafriend": "Elevate your living in Flagstaff! Refer a friend to Elevation and enjoy a vibrant community together. Great friends make great neighbors—join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Flagstaff, AZ Apartments for Rent",
  "property_seo_description_scheduletour": "Schedule a tour of Elevation Luxury Apartments in Flagstaff, AZ. Explore modern apartment homes, premium amenities, and a convenient East Flagstaff location.",
  "property_seo_title_privacy": "Privacy Policy | Elevation",
  "property_seo_description_privacy": "At Elevation in Flagstaff, AZ, we prioritize your privacy. Dive into our policy to see how we protect your information and enhance your living experience.",
  "property_seo_title_accessibility": "Website Accessibility | Elevation",
  "property_seo_description_accessibility": "Experience inclusivity at Elevation in Flagstaff, AZ. Our commitment to accessibility ensures all residents feel at home. Join our vibrant community today!",
  "property_seo_title_sitemap": "Sitemap | Elevation",
  "property_seo_description_sitemap": "Uncover every corner of Elevation in Flagstaff, AZ. Navigate your path to modern living and find your perfect home with our interactive sitemap.",
  "property_seo_title_thankyou": "Thank You | Apartments for Rent in Flagstaff, AZ",
  "property_seo_description_thankyou": "Thank you for contacting Elevation Luxury Apartments in Flagstaff, AZ. A member of our leasing team will be in touch shortly to assist you.",
  "property_seo_title_pets": "Pets | Apartments in Flagstaff, AZ",
  "property_seo_description_pets": "At Elevation in Flagstaff, AZ, our pet-friendly community invites cats and dogs to join you in creating memories.",
  "property_updated_at": "1786643063078",
  "amenities": [
    {
      "id": "custom_26ebc1b8-042c-4b61-9e89-97b8827d217e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Kitchen With Gas BBQ Grill",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f4c4ddf0-60b8-47d2-85b8-2ae56057c0dc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Amazon Hub Package Lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_c5a25746-3b8d-4e86-a8e7-36d0a4f7ba76",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Community Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ba433c44-0cfd-4805-ae1f-060dd8860992",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse With Wi-Fi",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_846ae714-d215-4c3e-9d2f-0090aff7452a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Pet-Friendly Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_81570a49-7439-47cb-80ae-1a1db685696c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Assigned Covered Carports",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f96b5dd7-50f3-44b3-a99e-74f2961e23fa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_af5f166a-367b-45de-9463-a163470a43e0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Scenic Mountain Views",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_c0d60dd4-01b7-4971-9c21-8636066309f5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center With Spin/Yoga Studio",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_59e1817f-59a5-4ca9-a386-01b5cd7461bf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Complimentary Coffee Bar",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e9a88fbf-2e03-4cd9-8b76-1590c4de621d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Large Pet Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e415efe1-5044-4d16-8970-d07969e52361",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4630b0d7-e6bd-4be5-a284-c05d10654817",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_228db416-f869-4c56-86dd-6e57ea6ef1c5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Year Round Heated Pool and Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e04c369a-99e9-4c6c-8f84-dac6e6103c3e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Minutes To Mount Elden Hiking & Biking Trails",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_505645f2-d0b1-455e-86bc-f63ecf7dfcc9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Ample Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_aa01fdec-ffea-420b-a821-043958a3b3a3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Island",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a7218ec2-e5ca-4f56-9794-5595d7b6f6bd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Open Concept Layout (Dining Room & Living Room)",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_eed1f012-21cd-4ee7-98b7-dfb6b95524cd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio/Balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ebc7c077-2ddd-493a-bdbf-cf0064cc2adc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood-Like Vinyl Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_2db18989-c8c7-48a1-b673-4f161ffa72ac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "9 Foot Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_6d6c4a73-6243-4e2d-8669-2c2475d6030f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Built-In Desk",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_c48aaed5-d04f-4853-a676-17d9b52069f5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Elegant Lighting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_3fa9c744-51cd-424f-93d7-d452aad4a1ff",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_29ba5ba8-49bb-42f0-8580-f3c662e11385",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Large Bathrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_57db4aa1-e8ef-4cb4-b228-44291872c51d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d0fd0422-1cc0-4b3a-a8b4-59a5f3a5f043",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Closet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7c791266-2bce-4a4c-894e-48d345d4cfc7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Sleek Modern Cabinetry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f4453f73-395d-4b60-91ef-39390011b8f8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_2b2b299e-af40-40ae-aaec-fc72790dbaa1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Bathroom Vanity",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_3550d480-c2e7-4a98-8540-811dea4999c6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceiling (In Select Apartments)",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_b9b9e09f-8e26-40e1-936a-f49c94755f5d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Over Sized Dual Pane Windows",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_764a83bd-f3f8-4b16-9938-b708762c7b26",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Additional Storage Available",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e1f459a6-7593-4a3f-a6b6-ccb90ff68d45",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "external_id": "false",
      "title": "Property Wide Fiber Internet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_50d01f58-7c08-40cc-8a1c-fcc2a1883798",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-8d46-7792-9d52-d632416f1b23.webp",
      "image_media": {
        "alt_text": "Entrance to a multifamily property with stone accents and lush landscaping at Elevation in Flagstaff, AZ.",
        "public_id": "01a01126-8d46-7792-9d52-d632416f1b23",
        "storage_key": "property/6767906449166432/01a01126-8d46-7792-9d52-d632416f1b23.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to the entrance of this beautiful multifamily property, featuring natural stone accents and vibrant landscaping for a welcoming first impression.",
      "link": "",
      "alt_text": "Entrance to a multifamily property with stone accents and lush landscaping at Elevation in Flagstaff, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b036d932-d71b-4da1-afb4-c2a8fc4946d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-8ece-76a2-b6ac-a253dfb25f34.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and stone accents at Elevation in Flagstaff, AZ.",
        "public_id": "01a01126-8ece-76a2-b6ac-a253dfb25f34",
        "storage_key": "property/6767906449166432/01a01126-8ece-76a2-b6ac-a253dfb25f34.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Showcasing the charming exterior of the apartment building, featuring spacious balconies and attractive stone details.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment building with balconies and stone accents at Elevation in Flagstaff, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2a897747-36c5-49e8-8d66-2d87e3b1daf4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-acbd-76bc-a678-6f94d53a39af.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and trees in the foreground at Elevation in Flagstaff, AZ.",
        "public_id": "01a01126-acbd-76bc-a678-6f94d53a39af",
        "storage_key": "property/6767906449166432/01a01126-acbd-76bc-a678-6f94d53a39af.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautiful apartment buildings with attractive landscaping and mountain views. Enjoy spacious living in a vibrant community.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and trees in the foreground at Elevation in Flagstaff, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cf2eac5f-e906-49ce-a0f8-73489d8087d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-36d8-71fc-8a75-2988a6423254.webp",
      "image_media": {
        "alt_text": "The lounge area of a luxury apartment complex, featuring a coffee station, a pool table, and comfortable seating.",
        "public_id": "01a01126-36d8-71fc-8a75-2988a6423254",
        "storage_key": "property/6767906449166432/01a01126-36d8-71fc-8a75-2988a6423254.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our resident lounge, complete with a complimentary coffee bar, a billiards table for some friendly competition, and ample seating for socializing.",
      "link": "",
      "alt_text": "The lounge area of a luxury apartment complex, featuring a coffee station, a pool table, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d8909cf9-2f61-4cec-80aa-0b4d41262825",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-5c95-77a6-bdb1-c5dd16a0fa82.webp",
      "image_media": {
        "alt_text": "Community lounge with a pool table, fireplace, and seating areas at Elevation in Flagstaff, AZ.",
        "public_id": "01a01126-5c95-77a6-bdb1-c5dd16a0fa82",
        "storage_key": "property/6767906449166432/01a01126-5c95-77a6-bdb1-c5dd16a0fa82.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy leisure time in our spacious community lounge, featuring a billiards table, a cozy fireplace, and comfortable seating.",
      "link": "",
      "alt_text": "Community lounge with a pool table, fireplace, and seating areas at Elevation in Flagstaff, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_75c8a33a-dd50-42d5-a306-9c2ef511a2a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-7276-708b-a066-2ee1309a3cdd.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, weight machines, and exercise bikes at Elevation in Flagstaff, AZ.",
        "public_id": "01a01126-7276-708b-a066-2ee1309a3cdd",
        "storage_key": "property/6767906449166432/01a01126-7276-708b-a066-2ee1309a3cdd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center, featuring a wide range of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, weight machines, and exercise bikes at Elevation in Flagstaff, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3e52c407-d3b8-4e01-9ed9-8da1614d9f71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-2a94-7449-9b92-a4294441087d.webp",
      "image_media": {
        "alt_text": "Fitness center with exercise bikes, yoga mats, and free weights at Elevation in Flagstaff, AZ.",
        "public_id": "01a01126-2a94-7449-9b92-a4294441087d",
        "storage_key": "property/6767906449166432/01a01126-2a94-7449-9b92-a4294441087d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, free weights, and space for yoga and stretching.",
      "link": "",
      "alt_text": "Fitness center with exercise bikes, yoga mats, and free weights at Elevation in Flagstaff, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d8b19f04-fe4f-4734-928b-fe88b0212b48",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01125-f7ea-7308-aee5-182facb65398.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas at a multifamily property.",
        "public_id": "01a01125-f7ea-7308-aee5-182facb65398",
        "storage_key": "property/6767906449166432/01a01125-f7ea-7308-aee5-182facb65398.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and shaded by colorful umbrellas.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and umbrellas at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_748c3f24-da8e-4a8a-a84d-5e3a2c6bc2b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-a94d-7505-8a46-4c566559486e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub at the Elevation Luxury Apartments complex.",
        "public_id": "01a01126-a94d-7505-8a46-4c566559486e",
        "storage_key": "property/6767906449166432/01a01126-a94d-7505-8a46-4c566559486e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool and soothing hot tub at Elevation Luxury Apartments.",
      "link": "",
      "alt_text": "Outdoor swimming pool and hot tub at the Elevation Luxury Apartments complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ad5c1acd-adbf-4710-923e-1552c7b2287c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-3730-766b-a561-81a4436c24f8.webp",
      "image_media": {
        "alt_text": "Elevation Luxury Apartments exterior sign and outdoor pool area with hot tub and lounge chairs.",
        "public_id": "01a01126-3730-766b-a561-81a4436c24f8",
        "storage_key": "property/6767906449166432/01a01126-3730-766b-a561-81a4436c24f8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the resort-style amenities at Elevation Luxury Apartments, featuring a sparkling pool, relaxing hot tub, and comfortable lounge seating, all set against a backdrop of lush trees and modern architecture.",
      "link": "",
      "alt_text": "Elevation Luxury Apartments exterior sign and outdoor pool area with hot tub and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f3df6133-99c9-45c2-a15d-a2878363c6f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-9fac-768e-9fad-a590f1da89f5.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and hot tub area with lounge chairs and umbrellas.",
        "public_id": "01a01126-9fac-768e-9fad-a590f1da89f5",
        "storage_key": "property/6767906449166432/01a01126-9fac-768e-9fad-a590f1da89f5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and hot tub area, perfect for relaxing and soaking up the sun. Ample lounge chairs and umbrellas provide comfortable seating.",
      "link": "",
      "alt_text": "Resort-style swimming pool and hot tub area with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_60dd96d7-b444-42f3-852d-134dce6a3009",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-4b09-7498-a231-08778d40f6d6.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with grill and counter space under a pergola.",
        "public_id": "01a01126-4b09-7498-a231-08778d40f6d6",
        "storage_key": "property/6767906449166432/01a01126-4b09-7498-a231-08778d40f6d6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with a built-in grill and spacious counter area, perfect for entertaining.",
      "link": "",
      "alt_text": "Outdoor kitchen with grill and counter space under a pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8f85012d-f966-471d-9e95-b3107d6b505d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-164a-74d2-98bf-c1ea18378598.webp",
      "image_media": {
        "alt_text": "Playground equipment with slides and benches with apartment buildings in the background at Elevation in Flagstaff, AZ.",
        "public_id": "01a01126-164a-74d2-98bf-c1ea18378598",
        "storage_key": "property/6767906449166432/01a01126-164a-74d2-98bf-c1ea18378598.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, perfect for families.",
      "link": "",
      "alt_text": "Playground equipment with slides and benches with apartment buildings in the background at Elevation in Flagstaff, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cfb8113d-5626-4280-b57f-9b80c198e39d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01125-ee2c-7535-8922-abbf96165491.webp",
      "image_media": {
        "alt_text": "Playground with slides and benches in a residential community.",
        "public_id": "01a01125-ee2c-7535-8922-abbf96165491",
        "storage_key": "property/6767906449166432/01a01125-ee2c-7535-8922-abbf96165491.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring slides and ample seating for relaxation.",
      "link": "",
      "alt_text": "Playground with slides and benches in a residential community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_02b7a406-e61b-440c-b383-9a4d5e435dde",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-2ac3-7461-8761-12a74b2b770d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a breakfast bar with a sink at Elevation in Flagstaff, AZ.",
        "public_id": "01a01126-2ac3-7461-8761-12a74b2b770d",
        "storage_key": "property/6767906449166432/01a01126-2ac3-7461-8761-12a74b2b770d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this stylish kitchen, featuring modern appliances, ample cabinet space, and a convenient breakfast bar.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a breakfast bar with a sink at Elevation in Flagstaff, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_44d44bf0-c7be-4227-910f-96eee0ba0473",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-5ab6-776a-9b0d-7f65ace801d2.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with dining table and patio access at Elevation in Flagstaff, AZ.",
        "public_id": "01a01126-5ab6-776a-9b0d-7f65ace801d2",
        "storage_key": "property/6767906449166432/01a01126-5ab6-776a-9b0d-7f65ace801d2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and stylish apartment living area featuring a modern kitchen, dining space, and access to a private patio.",
      "link": "",
      "alt_text": "Modern kitchen and living area with dining table and patio access at Elevation in Flagstaff, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ea4020d1-738a-4776-b270-a23e31d3c7b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-546a-7683-a9aa-66d39faa5495.webp",
      "image_media": {
        "alt_text": "Living room with white sofa, coffee table, and TV at Elevation in Flagstaff, AZ.",
        "public_id": "01a01126-546a-7683-a9aa-66d39faa5495",
        "storage_key": "property/6767906449166432/01a01126-546a-7683-a9aa-66d39faa5495.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable white sofa, a modern marble coffee table, and a sleek entertainment console with a television.",
      "link": "",
      "alt_text": "Living room with white sofa, coffee table, and TV at Elevation in Flagstaff, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_99d67de2-f6e5-4d83-92f2-f8716945e70f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-57a1-747d-8e83-84139a1d0409.webp",
      "image_media": {
        "alt_text": "A cozy bedroom featuring a queen-size bed with white linens, green and blue accent pillows, and two framed abstract artworks on the wall at Elevation in Flagstaff, AZ.",
        "public_id": "01a01126-57a1-747d-8e83-84139a1d0409",
        "storage_key": "property/6767906449166432/01a01126-57a1-747d-8e83-84139a1d0409.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom. Featuring a plush queen-size bed, elegant decor, and ample natural light, it's the perfect retreat.",
      "link": "",
      "alt_text": "A cozy bedroom featuring a queen-size bed with white linens, green and blue accent pillows, and two framed abstract artworks on the wall at Elevation in Flagstaff, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_72830ebd-918c-49af-a4fc-81e98c5ed7c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-57f6-7383-b5d3-a9912b244bb5.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower/tub combo at Elevation in Flagstaff, AZ.",
        "public_id": "01a01126-57f6-7383-b5d3-a9912b244bb5",
        "storage_key": "property/6767906449166432/01a01126-57f6-7383-b5d3-a9912b244bb5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Sparkling clean bathroom featuring a single vanity with modern fixtures, a toilet, and a pristine white shower/tub combination with a curtain.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and shower/tub combo at Elevation in Flagstaff, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_62cc254c-178b-4618-bdfd-e18066d81f9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/01a01126-767e-75b6-a3b6-5d001421e4a3.webp",
      "image_media": {
        "alt_text": "Modern bedroom with king-size bed and abstract wall art at Elevation in Flagstaff, AZ.",
        "public_id": "01a01126-767e-75b6-a3b6-5d001421e4a3",
        "storage_key": "property/6767906449166432/01a01126-767e-75b6-a3b6-5d001421e4a3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom. Featuring a plush king-size bed and contemporary decor, it's the perfect retreat.",
      "link": "",
      "alt_text": "Modern bedroom with king-size bed and abstract wall art at Elevation in Flagstaff, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_94226d15-82d3-4073-8c7f-bc68847c471d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Fat Olives",
      "poi_type": "Restaurants",
      "poi_address": "2308 E Rte 66, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Pizza joint featuring pies baked in a wood-fired oven, plus pasta dishes, salads and other Italian staples.",
      "poi_long_description": "People say this Italian restaurant serves delicious wood-fired pizza, pasta, and salads, with gluten-free options available. They highlight the authentic, flavorful dishes, and the generous portions. They also like the cozy atmosphere and friendly, attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c8-e8d5-72d2-9aff-e5d80b1561ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-e8d5-72d2-9aff-e5d80b1561ed",
        "storage_key": "property/6767906449166432/019d02c8-e8d5-72d2-9aff-e5d80b1561ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.fatolivesflagstaff.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13120998088840018413&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fat-olives",
      "poi_latitude": "35.2051628",
      "poi_longitude": "-111.6146596",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 928-853-0056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-26c6-7518-9b4e-7f248212447b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-26c6-7518-9b4e-7f248212447b",
        "storage_key": "property/6767906449166432/019d02c9-26c6-7518-9b4e-7f248212447b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG82i0t6OLYcR7XnjZz4mF7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_7cbeabfe-4e0b-44ba-9171-d27f4b3b9e8b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Flagstaff City-Coconino County Public Library",
      "poi_type": "Education",
      "poi_address": "300 W Aspen Ave, Flagstaff, AZ 86001, USA",
      "poi_short_description": "Public library with a children's section and a fireplace, plus self-checkout, computers, and Wi-Fi.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c8-f9f7-74bf-b794-df07e771d35b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-f9f7-74bf-b794-df07e771d35b",
        "storage_key": "property/6767906449166432/019d02c8-f9f7-74bf-b794-df07e771d35b.webp",
        "width": 1280,
        "height": 951
      },
      "poi_business_url": "https://www.flagstaffpubliclibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=729203163292154479&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "flagstaff-city-coconino-county-public-library",
      "poi_latitude": "35.2000944",
      "poi_longitude": "-111.6524578",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 928-213-2330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-26ce-7738-bc03-3957bec8c17f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-26ce-7738-bc03-3957bec8c17f",
        "storage_key": "property/6767906449166432/019d02c9-26ce-7738-bc03-3957bec8c17f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxUQw5ESPLYcRb7oe3WmmHgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_3ba65811-f6b8-4d9a-b75d-0afb6b310efe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4650 US-89 B2, Flagstaff, AZ 86004, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of machines, massage chairs, and hot showers. They also highlight the friendly staff and clean facilities.\n\nOther reviews mention the water pressure can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-04b7-7058-8b43-b641d383220a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-04b7-7058-8b43-b641d383220a",
        "storage_key": "property/6767906449166432/019d02c9-04b7-7058-8b43-b641d383220a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/flagstaff-east-az?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=5013447482053314657&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.2227798",
      "poi_longitude": "-111.5823152",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 928-326-2990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0A7HLePLYcRYUjdK-xXk0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_64318274-973e-4b32-8d89-ef792b14fa78",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Canyon Pet Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1054 E Old Canyon Ct, Flagstaff, AZ 86001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-0595-7362-8bf1-7de5f471c1f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-0595-7362-8bf1-7de5f471c1f6",
        "storage_key": "property/6767906449166432/019d02c9-0595-7362-8bf1-7de5f471c1f6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.canyonpet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17006428468768086813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "canyon-pet-hospital",
      "poi_latitude": "35.1896489",
      "poi_longitude": "-111.6383894",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 928-774-5197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3bYZRSPLYcRHRsDo5b4Auw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_25e41a43-d1e0-4d99-b2df-fb0aec36ca25",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Flagstaff Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "1001 N Turquoise Dr, Flagstaff, AZ 86001, USA",
      "poi_short_description": "Nonprofit fitness center with free weights, machines, basketball courts, and child care, plus a sauna.",
      "poi_long_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-0b97-7318-b84c-a1795596eb81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-0b97-7318-b84c-a1795596eb81",
        "storage_key": "property/6767906449166432/019d02c9-0b97-7318-b84c-a1795596eb81.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.valleyymca.org/flagstaff/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4374065913056460187&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "flagstaff-family-ymca",
      "poi_latitude": "35.2048989",
      "poi_longitude": "-111.6393569",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 928-637-6590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy3zfxjmPLYcRm_3f68XNszw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b8e2cd1f-3bba-4e1c-8d4a-914e76ca3aa4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2500 S Woodlands Village Blvd, Flagstaff, AZ 86001, USA",
      "poi_short_description": "Chain fitness center offering 24-hour access, plus personal training and group workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-0af2-71c9-bf66-65a623640d13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-0af2-71c9-bf66-65a623640d13",
        "storage_key": "property/6767906449166432/019d02c9-0af2-71c9-bf66-65a623640d13.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/flagstaff-arizona-259/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=259",
      "poi_directions_map_url": "https://maps.google.com/?cid=16142775090054431116&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "35.1778079",
      "poi_longitude": "-111.6665022",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 928-226-7064",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa27SvoeFLYcRjAG4k2qoBuA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5b35470e-9453-41d5-85c6-325ef3c5e47c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Surgeon Cuts Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "1000 E Butler Ave Suite #115 Second floor, Flagstaff, AZ 86001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-0c37-713e-9727-6f982c058889.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-0c37-713e-9727-6f982c058889",
        "storage_key": "property/6767906449166432/019d02c9-0c37-713e-9727-6f982c058889.webp",
        "width": 1038,
        "height": 1280
      },
      "poi_business_url": "http://surgeoncutsbarbershop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2353037922457221736&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "surgeon-cuts-barbershop",
      "poi_latitude": "35.1921717",
      "poi_longitude": "-111.6369248",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 928-405-2958",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5y5VgP6PLYcRaPoVB4arpyA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_ecae85da-e22b-4ef8-a897-85d5b989d725",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "D-Luxe Barbershop | Flagstaff barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "Next to parking lot, 18 1/2 N Leroux St, Flagstaff, AZ 86001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-10d7-761d-9c03-c044f9c5fc5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-10d7-761d-9c03-c044f9c5fc5c",
        "storage_key": "property/6767906449166432/019d02c9-10d7-761d-9c03-c044f9c5fc5c.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.dluxebarbers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10472354080000075822&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "d-luxe-barbershop--flagstaff-barbershop",
      "poi_latitude": "35.1981269",
      "poi_longitude": "-111.6487006",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 928-707-1227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2-YZJpiPLYcRLmiEBI1GVZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_26e7acfa-0fb5-44cd-9087-318686379da8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "3470 E Rte 66 #107, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Walk-in hair salon offering men's, women's, and children's haircuts, plus beard trims.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-0e5e-728e-a42f-e94731b4ed9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-0e5e-728e-a42f-e94731b4ed9c",
        "storage_key": "property/6767906449166432/019d02c9-0e5e-728e-a42f-e94731b4ed9c.webp",
        "width": 888,
        "height": 500
      },
      "poi_business_url": "https://salons.greatclips.com/us/az/flagstaff/3470-e-route-66?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11671791026700426621&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "35.2147974",
      "poi_longitude": "-111.5990183",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 928-526-4080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw7jn0NuOLYcRfR0SVxmI-qE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_4c2660bf-0ded-4e2a-8919-bd1fb54cf7fc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Sport Clips Haircuts of Flagstaff Aspen Place",
      "poi_type": "Health and Wellness",
      "poi_address": "319 Regent St #211, Flagstaff, AZ 86001, USA",
      "poi_short_description": "Men's haircare specialists offering steamed-towel treatments, sports on TV, and online check-in.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-11d5-75a0-8937-28f5be6ffd1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-11d5-75a0-8937-28f5be6ffd1b",
        "storage_key": "property/6767906449166432/019d02c9-11d5-75a0-8937-28f5be6ffd1b.webp",
        "width": 1279,
        "height": 720
      },
      "poi_business_url": "https://sportclips.com/us-az-flagstaff-az403?utm_source=google&utm_medium=link&utm_campaign=gbp&utm_content=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=15349608529414239753&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sport-clips-haircuts-of-flagstaff-aspen-place",
      "poi_latitude": "35.1918918",
      "poi_longitude": "-111.6427591",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 928-774-9109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbbvHKWuPLYcRCbYKvaHDBNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_cb263df3-5d76-4eca-824a-b22e3e252c9e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "NAU Health and Learning Center",
      "poi_type": "Health and Wellness",
      "poi_address": "824 S San Francisco St, Flagstaff, AZ 86011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-1173-76ed-9a94-8cbd2cfaa20e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-1173-76ed-9a94-8cbd2cfaa20e",
        "storage_key": "property/6767906449166432/019d02c9-1173-76ed-9a94-8cbd2cfaa20e.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "https://in.nau.edu/health-learning-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=681679904233780513&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nau-health-and-learning-center",
      "poi_latitude": "35.1900739",
      "poi_longitude": "-111.6510088",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 928-523-2131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2ae3-70e8-9d5f-00e0c28c4b9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2ae3-70e8-9d5f-00e0c28c4b9f",
        "storage_key": "property/6767906449166432/019d02c9-2ae3-70e8-9d5f-00e0c28c4b9f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJe5Rz5WiPLYcRIXVg3kLQdQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fbe65fa1-ca21-4ae4-ad71-0e2cbcfdf0d7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Flagstaff VA Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "1300 W University Ave, Flagstaff, AZ 86001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-1326-766e-83bb-47ce92bc2d4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-1326-766e-83bb-47ce92bc2d4e",
        "storage_key": "property/6767906449166432/019d02c9-1326-766e-83bb-47ce92bc2d4e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.va.gov/northern-arizona-health-care/locations/flagstaff-va-clinic/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12129426477076927424&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "flagstaff-va-clinic",
      "poi_latitude": "35.1846332",
      "poi_longitude": "-111.6725699",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 928-226-1056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2a71-709d-bf28-c0820be944a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2a71-709d-bf28-c0820be944a1",
        "storage_key": "property/6767906449166432/019d02c9-2a71-709d-bf28-c0820be944a1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw1mWDoyFLYcRwFNjzx1hVKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f8b27dac-94cf-4926-be29-cad4bc878c64",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Walnut Canyon National Monument",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Arizona, USA",
      "poi_short_description": "Hikeable canyon with cliff dwellings dating back to the 12th century.",
      "poi_long_description": "People say this national monument offers stunning views of a canyon and ancient cliff dwellings, and provides a glimpse into the region's past. They highlight the peaceful and beautiful atmosphere, and the interesting way the flora varies due to microclimates. They also like the well-maintained trails, the informative visitor center, and the helpful park rangers. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-1612-7089-8720-089a5f7f5c87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-1612-7089-8720-089a5f7f5c87",
        "storage_key": "property/6767906449166432/019d02c9-1612-7089-8720-089a5f7f5c87.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nps.gov/waca/index.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=15564833588045969360&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "walnut-canyon-national-monument",
      "poi_latitude": "35.1690189",
      "poi_longitude": "-111.5043369",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 928-526-3367",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2db3-765e-af6c-30b4d8022f7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2db3-765e-af6c-30b4d8022f7d",
        "storage_key": "property/6767906449166432/019d02c9-2db3-765e-af6c-30b4d8022f7d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu5D_YT-NLYcR0HeMq65lAdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "national_park"
    },
    {
      "id": "custom_1da181c6-1652-437c-8992-35bb6280e716",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Buffalo Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2400 N Gemini Rd, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Local nature reserve with an expansive meadow, deer, mountain views and a 2-mile Volcano Cinder Trail.",
      "poi_long_description": "People say this park offers scenic hiking trails, perfect for walking, running, and biking, with stunning views of the mountains and sky. They highlight the family-friendly, dog-friendly, and peaceful atmosphere, as well as the wide, well-maintained trails suitable for all skill levels. They also like the opportunities for picnics, star gazing, and enjoying sunsets and sunrises.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-17c4-74aa-92f3-c4d132ae4107.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-17c4-74aa-92f3-c4d132ae4107",
        "storage_key": "property/6767906449166432/019d02c9-17c4-74aa-92f3-c4d132ae4107.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flagstaff.az.gov/1923/City-Parks-Ramadas",
      "poi_directions_map_url": "https://maps.google.com/?cid=4140230258523771578&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "buffalo-park",
      "poi_latitude": "35.2185163",
      "poi_longitude": "-111.6329976",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 928-213-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2db3-765e-af6c-30b4d8022f7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2db3-765e-af6c-30b4d8022f7d",
        "storage_key": "property/6767906449166432/019d02c9-2db3-765e-af6c-30b4d8022f7d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxcrwF8yILYcRuhKi93sNdTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_87d83aa7-abb5-46a7-bae4-f2d3f08fecb1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Thorpe Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "191 N Thorpe Rd, Flagstaff, AZ 86001, USA",
      "poi_short_description": "Park featuring a tennis court, a playground, and a picnic area with barbecue grills, plus disc golf.",
      "poi_long_description": "People say this park offers a variety of play structures, including slides, swings, and musical instruments, as well as tennis courts, basketball courts, and a volleyball pit. They highlight the shaded grassy areas, picnic tables, and on-site restrooms, making it a great place for families to spend the day. They also like the clean and safe environment, and the fun and engaging atmosphere for children of all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-17e1-729d-8591-ee2bfb5f8a00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-17e1-729d-8591-ee2bfb5f8a00",
        "storage_key": "property/6767906449166432/019d02c9-17e1-729d-8591-ee2bfb5f8a00.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9753705125292704760&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thorpe-park",
      "poi_latitude": "35.2025426",
      "poi_longitude": "-111.6584073",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2db3-765e-af6c-30b4d8022f7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2db3-765e-af6c-30b4d8022f7d",
        "storage_key": "property/6767906449166432/019d02c9-2db3-765e-af6c-30b4d8022f7d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ22hxQWqPLYcR-IP6VCIfXIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1fbc69ab-92b8-4596-a5da-8b98acfa08d6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Bushmaster Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3150 N Alta Vista Dr, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Park featuring basketball and tennis courts, plus a playground with a zipline.",
      "poi_long_description": "People say this park offers a variety of recreational activities, including playgrounds, zip lines, a skate park, tennis courts, basketball courts, and a dog park. They highlight the spacious, grassy areas, picnic tables, and barbecue pits, making it ideal for family gatherings and events. They also like the well-maintained grounds and the availability of shade. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-19d2-770b-8e10-3e437cd5e6d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-19d2-770b-8e10-3e437cd5e6d2",
        "storage_key": "property/6767906449166432/019d02c9-19d2-770b-8e10-3e437cd5e6d2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://flagstaff.az.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12028788265221371006&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bushmaster-park",
      "poi_latitude": "35.2170284",
      "poi_longitude": "-111.602725",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 928-213-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2db3-765e-af6c-30b4d8022f7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2db3-765e-af6c-30b4d8022f7d",
        "storage_key": "property/6767906449166432/019d02c9-2db3-765e-af6c-30b4d8022f7d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-Bhl86OLYcRfjToKjLX7qY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_721a6fc6-bf83-4a8d-b526-0ed105baa7e0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Fatmans Loop Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5098 US-89, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Trail loop featuring an ascent to lookout points over Flagstaff, plus forked paths for longer or shorter hikes.",
      "poi_long_description": "People say this hiking area offers a fun and challenging hike with beautiful views and interesting features like alligator juniper trees. They highlight the well-maintained trails, clear signage, and manageable elevation, making it suitable for various skill levels. They also like the peaceful environment and the opportunity to see wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-1c36-727f-a36e-67303ec17656.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-1c36-727f-a36e-67303ec17656",
        "storage_key": "property/6767906449166432/019d02c9-1c36-727f-a36e-67303ec17656.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fs.usda.gov/recarea/coconino/recarea/?recid=55094",
      "poi_directions_map_url": "https://maps.google.com/?cid=18435306953211378864&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fatmans-loop-trail",
      "poi_latitude": "35.2300764",
      "poi_longitude": "-111.5792996",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2db3-765e-af6c-30b4d8022f7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2db3-765e-af6c-30b4d8022f7d",
        "storage_key": "property/6767906449166432/019d02c9-2db3-765e-af6c-30b4d8022f7d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnU7Nq1OJLYcRsPxz3_9d1_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_fd8bac75-4a2c-47a0-b65f-253744858fdf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Grand Canyon Railway",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 W Rte 66 #200, Flagstaff, AZ 86001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-1d78-727e-a000-9bbc3944d94f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-1d78-727e-a000-9bbc3944d94f",
        "storage_key": "property/6767906449166432/019d02c9-1d78-727e-a000-9bbc3944d94f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thetrain.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9860644145140910747&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grand-canyon-railway",
      "poi_latitude": "35.1875332",
      "poi_longitude": "-111.6676977",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 928-773-1976",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi2z444qFLYcRm8qoJ5sL2Ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_32d522d9-abd9-4c7d-bee3-d2722805bcd0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "BNSF Flagstaff",
      "poi_type": "Major Employers & Offices",
      "poi_address": "128 E Phoenix Ave, Flagstaff, AZ 86001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-1f83-7552-9c0b-27942a4331dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-1f83-7552-9c0b-27942a4331dc",
        "storage_key": "property/6767906449166432/019d02c9-1f83-7552-9c0b-27942a4331dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5695383706035977347&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bnsf-flagstaff",
      "poi_latitude": "35.1960916",
      "poi_longitude": "-111.6473978",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbwlBnUGPLYcRg3zSIU4RCk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_04e7dab6-55fa-48c8-961a-b33fce7722f6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Kahtoola",
      "poi_type": "Major Employers & Offices",
      "poi_address": "431 S River Run Rd, Flagstaff, AZ 86001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.kahtoola.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3999668327041939820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kahtoola",
      "poi_latitude": "35.1895838",
      "poi_longitude": "-111.6366539",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 928-779-7249",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXZHo5BOPLYcRbDm3_CatgTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_313b1bb0-ff9d-468c-b39d-339c799e2ce7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Nackard Companies",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4900 E Railhead Ave, Flagstaff, AZ 86004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-21a7-714a-9e91-e98cee49153a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-21a7-714a-9e91-e98cee49153a",
        "storage_key": "property/6767906449166432/019d02c9-21a7-714a-9e91-e98cee49153a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nackard.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7837088881842984536&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nackard-companies",
      "poi_latitude": "35.2261265",
      "poi_longitude": "-111.5745519",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 928-526-0653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9X5m-KqOLYcRWBZqu9Duwmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1e7f58e2-25a2-4025-86e0-dfc89881c8cb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Oregano's",
      "poi_type": "Restaurants",
      "poi_address": "980 N Country Club Dr, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Unfussy family restaurant with a menu of classic pizzas as well as other Italian dishes.",
      "poi_long_description": "Customers consistently praise this restaurant for its delicious deep-dish pizza, pasta, and salads, often mentioning the generous portion sizes. The friendly staff, reasonable prices, and fun, nostalgic atmosphere are also frequently highlighted.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019eb36e-f25c-75ae-ae3e-532d8b357b90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb36e-f25c-75ae-ae3e-532d8b357b90",
        "storage_key": "property/6767906449166432/019eb36e-f25c-75ae-ae3e-532d8b357b90.webp",
        "width": 1280,
        "height": 871
      },
      "poi_business_url": "https://oreganos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16290106604091426476&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oreganos",
      "poi_latitude": "35.2144564",
      "poi_longitude": "-111.5792146",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-233-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-26c6-7518-9b4e-7f248212447b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-26c6-7518-9b4e-7f248212447b",
        "storage_key": "property/6767906449166432/019d02c9-26c6-7518-9b4e-7f248212447b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQeMFq6WOLYcRrEYd0qUVEuI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_84021231-21aa-4d04-8425-cf975abc2203",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2201 E Rte 66, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Diners say this steak house serves up delicious steaks, especially the ribeye and sirloin, alongside tasty rolls and sides like mashed potatoes. They also highlight the friendly and attentive service, reasonable prices, and lively atmosphere.\n\nSome reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-6019-7277-b499-38263a185d6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-6019-7277-b499-38263a185d6a",
        "storage_key": "property/6767906449166432/019d02c9-6019-7277-b499-38263a185d6a.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/arizona/flagstaff?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=8297776735023395724&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.20313489999999",
      "poi_longitude": "-111.6153581",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-522-9247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-26c6-7518-9b4e-7f248212447b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-26c6-7518-9b4e-7f248212447b",
        "storage_key": "property/6767906449166432/019d02c9-26c6-7518-9b4e-7f248212447b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHWmAHt-OLYcRjPORHPqfJ3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_50ea4e1b-5675-457b-b274-69cb244647d3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "NiMarco's Pizza East",
      "poi_type": "Restaurants",
      "poi_address": "3715 N Kaspar Dr, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Quick-serve pizza joint featuring thin and thick-crust pies: also on the menu are wings, salads, and beer.",
      "poi_long_description": "Diners say this pizza place offers delicious pizza with a crispy crust, flavorful wings, and fresh salads, including gluten-free and vegan cheese options. They also highlight the friendly staff, relaxed atmosphere, and convenient parking.\n\nSome reviews mention the service can be impolite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019eb36e-ef7b-769c-8326-04ee346e184e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb36e-ef7b-769c-8326-04ee346e184e",
        "storage_key": "property/6767906449166432/019eb36e-ef7b-769c-8326-04ee346e184e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nimarcospizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11659754931868516376&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nimarcos-pizza-east",
      "poi_latitude": "35.2173554",
      "poi_longitude": "-111.5942392",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-779-2691",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-26c6-7518-9b4e-7f248212447b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-26c6-7518-9b4e-7f248212447b",
        "storage_key": "property/6767906449166432/019d02c9-26c6-7518-9b4e-7f248212447b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLUHVpXmPLYcRGMAholXFz6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_5a65174a-2cb4-4e5c-ba05-cf8e223112de",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "The Oakmont",
      "poi_type": "Restaurants",
      "poi_address": "2380 N Oakmont Dr, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Spacious, airy & modern-industrial outpost serving American comfort cuisine & cocktails.",
      "poi_long_description": "Diners say this restaurant offers delicious food with generous portions, including notable dishes like green chili stew and Cajun pasta, and features beautiful views of the golf course and mountains. They also highlight the exceptional and attentive service from the staff, along with a welcoming, dog-friendly atmosphere on the patio.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019eb36e-ef16-7208-b168-c7dee30ad52f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb36e-ef16-7208-b168-c7dee30ad52f",
        "storage_key": "property/6767906449166432/019eb36e-ef16-7208-b168-c7dee30ad52f.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.oakmontflagstaff.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3510247549445323506&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-oakmont",
      "poi_latitude": "35.2025051",
      "poi_longitude": "-111.5800875",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-526-7990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-26c6-7518-9b4e-7f248212447b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-26c6-7518-9b4e-7f248212447b",
        "storage_key": "property/6767906449166432/019d02c9-26c6-7518-9b4e-7f248212447b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwTDmmpmOLYcR8rpfUozntjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_3404f367-08ec-42c7-9782-9f8ea5d0da31",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Mi Tesoro",
      "poi_type": "Restaurants",
      "poi_address": "4650 US-89, Flagstaff, AZ 86004, USA",
      "poi_short_description": "",
      "poi_long_description": "Diners like this restaurant's authentic and flavorful Mexican food, with many highlighting the birria tacos, molcajete, and ceviche. They also mention the reasonable prices, generous portions, and the clean, modern atmosphere. Guests consistently praise the friendly, attentive staff and excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019eb36e-ee73-738e-b548-f515d4a679bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb36e-ee73-738e-b548-f515d4a679bf",
        "storage_key": "property/6767906449166432/019eb36e-ee73-738e-b548-f515d4a679bf.webp",
        "width": 1280,
        "height": 1140
      },
      "poi_business_url": "https://mitesoromodernmex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2701871384409319278&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mi-tesoro",
      "poi_latitude": "35.2235603",
      "poi_longitude": "-111.5811004",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-526-7996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-26c6-7518-9b4e-7f248212447b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-26c6-7518-9b4e-7f248212447b",
        "storage_key": "property/6767906449166432/019d02c9-26c6-7518-9b4e-7f248212447b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPeIJTwCPLYcRbqeCgLX5fiU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b5fcfb83-d506-424e-8b2f-74bff13d8e95",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Marshalls",
      "poi_type": "Shopping & Retail",
      "poi_address": "5005 E Marketplace Dr, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_long_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019eb372-99f3-773b-96d8-9c9667aac3fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb372-99f3-773b-96d8-9c9667aac3fd",
        "storage_key": "property/6767906449166432/019eb372-99f3-773b-96d8-9c9667aac3fd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4654719587966145455&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "marshalls",
      "poi_latitude": "35.2223356",
      "poi_longitude": "-111.5740208",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-522-6075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-26d1-771c-acb0-6e13097e7f23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-26d1-771c-acb0-6e13097e7f23",
        "storage_key": "property/6767906449166432/019d02c9-26d1-771c-acb0-6e13097e7f23.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJs-PCjKyOLYcRr1PGsc3imEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_a9b79ff3-8a41-47bd-9da6-964e57abc44a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Old Navy",
      "poi_type": "Shopping & Retail",
      "poi_address": "5005 E Marketplace Dr Ste 140, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Chain with a wide range of clothing for the family from jeans to loungewear, plus fun accessories.",
      "poi_long_description": "Chain with a wide range of clothing for the family from jeans to loungewear, plus fun accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019eb372-9bca-711b-8394-81be59a89c69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb372-9bca-711b-8394-81be59a89c69",
        "storage_key": "property/6767906449166432/019eb372-9bca-711b-8394-81be59a89c69.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://oldnavy.gap.com/stores/az/flagstaff/oldnavy-5302.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12563295966393716942&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-navy",
      "poi_latitude": "35.2223605",
      "poi_longitude": "-111.5731553",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-526-1594",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-26d1-771c-acb0-6e13097e7f23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-26d1-771c-acb0-6e13097e7f23",
        "storage_key": "property/6767906449166432/019d02c9-26d1-771c-acb0-6e13097e7f23.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvYqGraMQM4cRztD-RB7LWa4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_0e8c5de6-ad5d-4b75-afff-e8d3d00d75b4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Hobby Lobby",
      "poi_type": "Shopping & Retail",
      "poi_address": "4800 US-89, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Chain carrying a variety of arts & crafts materials, plus party supplies, fabric & home-decor items.",
      "poi_long_description": "People say this craft store offers a wide selection of items. They highlight the store is clean, well-organized, and has plenty of parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019eb372-9dbf-7186-8da5-58c8c0019241.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb372-9dbf-7186-8da5-58c8c0019241",
        "storage_key": "property/6767906449166432/019eb372-9dbf-7186-8da5-58c8c0019241.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hobbylobby.com/stores/search/934",
      "poi_directions_map_url": "https://maps.google.com/?cid=13647124825960491996&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hobby-lobby",
      "poi_latitude": "35.2242957",
      "poi_longitude": "-111.5805331",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-526-0448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-26d1-771c-acb0-6e13097e7f23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-26d1-771c-acb0-6e13097e7f23",
        "storage_key": "property/6767906449166432/019d02c9-26d1-771c-acb0-6e13097e7f23.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJXYiKka6PLYcR3CvKQLlTZL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_3f09c950-0275-40b0-ae04-e8b959c4cf3c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "5005 E Marketplace Dr #130, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "People say this clothing store offers a wide variety of products and good deals.\n\nOther reviews mention the service can be unhelpful and the staff can be impolite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019eb372-9c18-76b8-bf4b-c09c00143e20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb372-9c18-76b8-bf4b-c09c00143e20",
        "storage_key": "property/6767906449166432/019eb372-9c18-76b8-bf4b-c09c00143e20.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=665002216131307564&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "35.22238919999999",
      "poi_longitude": "-111.5727005",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-526-7018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-26d1-771c-acb0-6e13097e7f23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-26d1-771c-acb0-6e13097e7f23",
        "storage_key": "property/6767906449166432/019d02c9-26d1-771c-acb0-6e13097e7f23.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP8_UlziPLYcRLKhaA_6POgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_109008ae-4dd0-4bab-8bf8-03f86d7cca33",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "World Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "5005 E Marketplace Dr #120, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Retail chain featuring an eclectic array of imported housewares, furniture, decor & specialty foods.",
      "poi_long_description": "Visitors say this store offers a wide variety of unique gifts, home furnishings, and international foods and snacks. They also highlight the reasonable prices and the fun, interesting environment. Others mention the staff are sweet, helpful, and friendly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019eb372-9b7e-70cf-a507-b1e41b7e5814.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb372-9b7e-70cf-a507-b1e41b7e5814",
        "storage_key": "property/6767906449166432/019eb372-9b7e-70cf-a507-b1e41b7e5814.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.worldmarket.com/stores/store?id=CP335",
      "poi_directions_map_url": "https://maps.google.com/?cid=4701188889444174248&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "world-market",
      "poi_latitude": "35.222287",
      "poi_longitude": "-111.5723553",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-526-1058",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-26d1-771c-acb0-6e13097e7f23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-26d1-771c-acb0-6e13097e7f23",
        "storage_key": "property/6767906449166432/019d02c9-26d1-771c-acb0-6e13097e7f23.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJs-PCjKyOLYcRqElVEWP6PUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_cf2e69eb-463a-45e2-bed2-949fbfa182a3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "5005 E Marketplace Dr #150, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Shoppers say this electronics store offers a wide variety of products, including cell phones, TVs, and audio equipment, and they appreciate the helpful and friendly staff. They also highlight the store's clean and well-stocked environment, and many find the order ahead option convenient.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019eb372-9c80-74db-b9c4-c265ec52697e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb372-9c80-74db-b9c4-c265ec52697e",
        "storage_key": "property/6767906449166432/019eb372-9c80-74db-b9c4-c265ec52697e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bestbuy.com/az/flagstaff/5005-e-marketplace-dr-1084.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=14482758298548782078&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "35.2223654",
      "poi_longitude": "-111.5736431",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-522-6141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-26d1-771c-acb0-6e13097e7f23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-26d1-771c-acb0-6e13097e7f23",
        "storage_key": "property/6767906449166432/019d02c9-26d1-771c-acb0-6e13097e7f23.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJs-PCjKyOLYcR_kPXiPAX_cg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_225e0d6a-14d2-48e1-a1be-54136354d67d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Harkins Theatres Flagstaff",
      "poi_type": "Entertainment",
      "poi_address": "4751 E Marketplace Dr, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_long_description": "People say this movie theater offers a great movie-going experience with comfortable seating, a well-stocked concession stand, and clean bathrooms. They also highlight the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019eb375-04f3-76ed-ba60-1ab7785782c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb375-04f3-76ed-ba60-1ab7785782c3",
        "storage_key": "property/6767906449166432/019eb375-04f3-76ed-ba60-1ab7785782c3.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://harkins.com/theatres/flagstaff?utm_source=google_listing&utm_medium=web&utm_campaign=gmb&utm_id=local_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8050870037684123075&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "harkins-theatres-flagstaff",
      "poi_latitude": "35.2227137",
      "poi_longitude": "-111.5771216",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-233-3005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019eb375-0a99-718d-90cb-8f0fdb96c2d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eb375-0a99-718d-90cb-8f0fdb96c2d1",
        "storage_key": "property/6767906449166432/019eb375-0a99-718d-90cb-8f0fdb96c2d1.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJgZSME62OLYcRw3X_2KRvum8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_d06a44e0-53da-4e0f-bbbf-873b08f939eb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Levitate Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "4601 E Marketplace Dr, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Clean entertainment center with trampolines for kids and adults alike, plus a snack bar and pizza.",
      "poi_long_description": "People say this trampoline park offers a variety of fun activities, including trampolines, a zip line, and an arcade, and many highlight the delicious pizza and ice cream. Visitors also appreciate the clean and well-maintained environment, with comfortable couches for parents to relax while watching their children. They also mention the friendly and helpful staff, as well as the reasonable prices and good value.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019eb375-0106-74ce-a4cc-1fde0f8b4821.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb375-0106-74ce-a4cc-1fde0f8b4821",
        "storage_key": "property/6767906449166432/019eb375-0106-74ce-a4cc-1fde0f8b4821.webp",
        "width": 1280,
        "height": 313
      },
      "poi_business_url": "https://www.levitate.fun/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4274195757530134835&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "levitate-adventure-park",
      "poi_latitude": "35.224853",
      "poi_longitude": "-111.5786596",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-900-5867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFzqBb8-PLYcRM7kQVGX-UDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_3af8b4b5-4a47-4958-aecf-814d535864bd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Starlite Lanes",
      "poi_type": "Entertainment",
      "poi_address": "3406 E Rte 66, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Lanes for pin bowling and cosmic bowling, plus an arcade and clean bathrooms.",
      "poi_long_description": "People say this bowling alley offers fun bowling and video games. They also highlight the family-friendly atmosphere, friendly staff, and clean facilities.\n\nOther reviews mention the pins can be on strings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019eb375-003c-76ff-83ae-7aa3c97d30bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb375-003c-76ff-83ae-7aa3c97d30bc",
        "storage_key": "property/6767906449166432/019eb375-003c-76ff-83ae-7aa3c97d30bc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.starlitelanes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16924992343947518751&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starlite-lanes",
      "poi_latitude": "35.2142601",
      "poi_longitude": "-111.5991962",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-526-1138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5YzLosiOLYcRH6MyR92m4eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_6994785b-412f-456f-b5dd-705c382f5507",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "PuttTek Flagstaff",
      "poi_type": "Entertainment",
      "poi_address": "3126 E Rte 66, Flagstaff, AZ 86004, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this mini golf course offers a fun and challenging experience with a well-designed layout suitable for all skill levels. Visitors also highlight the friendly and welcoming staff, as well as the reasonable prices. They also like the availability of snacks, ice cream, and drinks, along with clean restrooms and outdoor heaters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019eb375-00b7-702d-a870-b0921aae23db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb375-00b7-702d-a870-b0921aae23db",
        "storage_key": "property/6767906449166432/019eb375-00b7-702d-a870-b0921aae23db.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.facebook.com/profile.php?id=61576961605210",
      "poi_directions_map_url": "https://maps.google.com/?cid=10567234020755526317&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "putttek-flagstaff",
      "poi_latitude": "35.2126445",
      "poi_longitude": "-111.6021315",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-707-3392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3qEycOPLYcRrVKOsVpbppI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "miniature_golf_course"
    },
    {
      "id": "custom_c246f5b5-4a1e-4ceb-b966-9bcce4240931",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Mt Elden Lookout Trail",
      "poi_type": "Entertainment",
      "poi_address": "4870, 5098 US-89, Flagstaff, AZ 86004, USA",
      "poi_short_description": "This trail leads up to the summit of Mt. Elden & offers views of the city & surrounding area.",
      "poi_long_description": "Visitors say this trail offers fantastic views and a challenging, rewarding hike with diverse flora and fauna. They also highlight the convenient location near Flagstaff and the free parking. Others mention the well-marked trails and multiple route options, including less steep paths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019eb374-ffda-75bc-b845-e45d1e717c1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb374-ffda-75bc-b845-e45d1e717c1c",
        "storage_key": "property/6767906449166432/019eb374-ffda-75bc-b845-e45d1e717c1c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fs.usda.gov/recarea/coconino/recarea/?recid=55140",
      "poi_directions_map_url": "https://maps.google.com/?cid=18355961654947924415&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mt-elden-lookout-trail",
      "poi_latitude": "35.230138",
      "poi_longitude": "-111.5793861",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0SLpqFOJLYcRv8ncAd95vf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_eb51345a-88c9-4b0b-9a29-fe4f76601d78",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Cromer Elementary School",
      "poi_type": "Education",
      "poi_address": "7150 Silver Saddle Rd, Flagstaff, AZ 86004",
      "poi_short_description": "Zoned Flagstaff USD elementary school for the community.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "50",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_43d94cb8-3a92-4b69-982a-030ee9caefa9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Sinagua Middle School",
      "poi_type": "Education",
      "poi_address": "3950 E Butler Ave, Flagstaff, AZ 86004",
      "poi_short_description": "Zoned Flagstaff USD middle school for the community.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "60",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7bd7d4c3-488a-4ba9-bfc5-6ab1baadb24e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Coconino High School",
      "poi_type": "Education",
      "poi_address": "2801 N Izabel St, Flagstaff, AZ 86004",
      "poi_short_description": "Zoned Flagstaff USD high school for the community.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "60",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_734c5551-9882-45e3-b2b1-2c665a50926e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Foxglenn Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4200 E Butler Ave, Flagstaff, AZ 86004",
      "poi_short_description": "Closest east-Flagstaff park; skate park, ball fields and FUTS trail access.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "30",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6b6f06f7-c3cb-48c9-ad6f-f67095d80a37",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Mountain Line - Flagstaff Mall Connection Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Marketplace Dr & Mall Way, Flagstaff, AZ 86004",
      "poi_short_description": "Nearest Mountain Line transit hub (Routes 2, 3 and 66); walkable from the community.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e390578f-1afb-4862-81bd-621c63a3a141",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Mountain Line Route 66",
      "poi_type": "Transportation & Transit",
      "poi_address": "Flagstaff Mall Connection Center, Flagstaff, AZ 86004",
      "poi_short_description": "Mountain Line bus route serving the historic Route 66 corridor.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bb429265-d190-4ff9-9d0e-2cd10033fe89",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Mountain Line Route 2 (Blue)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Flagstaff Mall Connection Center, Flagstaff, AZ 86004",
      "poi_short_description": "Mountain Line bus route connecting east Flagstaff to downtown and NAU.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d9283507-7a90-4c34-920a-a656024e99dc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Flagstaff Pulliam Airport (FLG)",
      "poi_type": "Transportation & Transit",
      "poi_address": "6200 S Pulliam Dr, Flagstaff, AZ 86005",
      "poi_short_description": "Flagstaff's regional airport (American Eagle service to PHX/DFW).",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "190",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9b0bc2d9-832c-4f76-afb9-1759d7b41288",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Flagstaff Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 N Beaver St, Flagstaff, AZ 86001",
      "poi_short_description": "Region's largest hospital (Northern Arizona Healthcare) and a top employer.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "90",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_74bec481-d8a1-4ba4-b759-b38f1a4c7df1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "W.L. Gore & Associates",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1500 N Fourth St, Flagstaff, AZ 86004",
      "poi_short_description": "Major Flagstaff manufacturer (medical devices and GORE-TEX).",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "50",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_397e8ee6-eeb2-4ef9-943d-77092fd9077d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Foresight Learning Center Inc",
      "poi_type": "Education",
      "poi_address": "8245 Koch Field Rd, Flagstaff, AZ 86004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019f0580-8000-700a-9594-6a2bd8c6886f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0580-8000-700a-9594-6a2bd8c6886f",
        "storage_key": "property/6767906449166432/019f0580-8000-700a-9594-6a2bd8c6886f.webp",
        "width": 1280,
        "height": 899
      },
      "poi_business_url": "http://www.foresightlearningcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15986464969872691164&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "foresight-learning-center-inc",
      "poi_latitude": "35.2575522",
      "poi_longitude": "-111.524256",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-527-8337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-26ce-7738-bc03-3957bec8c17f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-26ce-7738-bc03-3957bec8c17f",
        "storage_key": "property/6767906449166432/019d02c9-26ce-7738-bc03-3957bec8c17f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW1Rt5p-LLYcR3M98rzBV290",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_063c549f-da8e-4fe5-ab30-be8b3ce8783a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Montessori School of Flagstaff - Sunnyside Campus",
      "poi_type": "Education",
      "poi_address": "2025 N East St, Flagstaff, AZ 86004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.flagmontessori.com/flagstaff-schools/private-flagstaff-preschool-sunnyside-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=3555254125200627260&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "montessori-school-of-flagstaff---sunnyside-campus",
      "poi_latitude": "35.2086715",
      "poi_longitude": "-111.6194565",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 928-779-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-26ce-7738-bc03-3957bec8c17f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-26ce-7738-bc03-3957bec8c17f",
        "storage_key": "property/6767906449166432/019d02c9-26ce-7738-bc03-3957bec8c17f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs_p_7yePLYcRPFbTUsrMVjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_35bb9aec-aee1-4854-9f8c-7f6cfc53a2a3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Mountain Line Route 10",
      "poi_type": "Transportation & Transit",
      "poi_address": "Flagstaff Mall Connection Center, 4650 N US-89, Flagstaff, AZ 86004",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1bbd6bcd-f773-4c17-8dd1-5004723a1bbf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Mountain Line Route 14",
      "poi_type": "Transportation & Transit",
      "poi_address": "Flagstaff Mall Connection Center, 4650 N US-89, Flagstaff, AZ 86004",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_77f3db50-e095-4058-bc45-83eb2b5ed9fd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "poi_name": "Flagstaff Aquaplex",
      "poi_type": "Entertainment",
      "poi_address": "1702 N Fourth St, Flagstaff, AZ 86004, USA",
      "poi_short_description": "Family-friendly fitness hub featuring an indoor track, a hot tub, a gym and a waterslide pool.",
      "poi_long_description": "Visitors say this recreation center offers a wide variety of indoor activities, including a pool with slides, a splash pad, a hot tub, and a rock climbing wall. They also highlight the clean facilities, helpful staff, and affordable prices, with discounts available.\n\nSome reviews mention the pool can be unexpectedly closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019f0583-9a72-75bc-93e9-406bfcf80bbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0583-9a72-75bc-93e9-406bfcf80bbe",
        "storage_key": "property/6767906449166432/019f0583-9a72-75bc-93e9-406bfcf80bbe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.flagstaff.az.gov/896/Aquaplex",
      "poi_directions_map_url": "https://maps.google.com/?cid=14005933640325437372&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "flagstaff-aquaplex",
      "poi_latitude": "35.205069",
      "poi_longitude": "-111.6105868",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 928-213-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-2abb-705f-8160-d2ece3996f4a",
        "storage_key": "property/6767906449166432/019d02c9-2abb-705f-8160-d2ece3996f4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVXwgd9yOLYcRvJdKc3ASX8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    }
  ],
  "office_hours": [
    {
      "id": "ec_659d7cd855f16de439b905ec",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_95b4929b5fe32efc3064b919",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_31256a1596ac19083af7b77c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_41be8334269f63cbe65b02b3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c989b06b6a70a2e5540f570b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6951494d49faf513b96b657a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_675384ba-0314-4931-847a-0572a24cd0d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "rating": "5.0",
      "name": "Dwayne Rodriguez",
      "text": "Just wanted to give a shout out to Elevation for the absolutely amazing staff and maintenance. Came here back in 2023, and ever since then we've had our home get better and better, with great neighbors and community to boot. Very proud of how everything has come together and plan on staying here a very long time.",
      "date": "2025-08-16",
      "title": ""
    },
    {
      "id": "custom_40279eaf-6950-4352-96ee-17dc3e4211b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "rating": "5.0",
      "name": "Melissa Lester",
      "text": "My husband and I were so nervous at first when we came into the office. Christine Marino, Assistant Manager was very helpful, she made us feel welcomed and she made the whole move in smooth. We also got a small move in gift with Starbucks gift card. She was very nice and helpful. My family and I are happy with our new place. The theater and the mall is right across the street. We moved into a three bedroom and it's beautiful and already feels comfy. 🔑\nThank you Christine for helping us. Your awesome.  👍",
      "date": "2023-11-18",
      "title": ""
    },
    {
      "id": "custom_6444b6a9-c115-4270-ae6e-18c5f6aaca83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "rating": "5.0",
      "name": "Andrew Aliser",
      "text": "The leasing office, especially Rachelle, provided excellent customer service and assisted with the application process at every stop. They were able to process my application and get me in an apartment within a weekend.",
      "date": "2025-09-29",
      "title": ""
    },
    {
      "id": "custom_71f9204a-7ee2-4148-abef-25ed20fe1ddd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "rating": "5.0",
      "name": "Wyatt Peysar",
      "text": "Had a few things to take care of in the apartment and Giovanni came over to help out very promptly. He was very professional and I was impressed with his workmanship. All around a great experience!",
      "date": "2025-08-14",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_3920f324-622f-4468-9426-fb3404d09422",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-8d28-7594-bb4b-a6455a262b19.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a granite countertop island.",
        "public_id": "019d02c9-8d28-7594-bb4b-a6455a262b19",
        "storage_key": "property/6767906449166432/019d02c9-8d28-7594-bb4b-a6455a262b19.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 1005 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=jJBKLEUkRVM"
    },
    {
      "id": "custom_e14d8aec-2c6f-46e4-9a6f-769a38d96a3e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-fe70-756b-8b56-0fd88149a1d7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with dark cabinets, granite countertops, stainless steel sink, and black appliances.",
        "public_id": "019d02c9-fe70-756b-8b56-0fd88149a1d7",
        "storage_key": "property/6767906449166432/019d02c9-fe70-756b-8b56-0fd88149a1d7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 3 BR, 2 BA | 1158 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ZG74wrjmqGX"
    },
    {
      "id": "custom_0ea95212-6f9d-42ff-a216-2976a10fc60e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-fe66-749f-9b5c-c2896c0ffa0b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and weight machines.",
        "public_id": "019d02c9-fe66-749f-9b5c-c2896c0ffa0b",
        "storage_key": "property/6767906449166432/019d02c9-fe66-749f-9b5c-c2896c0ffa0b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=YD6E9TDNUa8"
    },
    {
      "id": "custom_a2124fe2-0542-44fc-8f1e-41bce40ec009",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019d02c9-9886-701e-bfea-5f4ff74b96ed.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Community lounge area with seating, dining table, and kitchenette.",
        "public_id": "019d02c9-9886-701e-bfea-5f4ff74b96ed",
        "storage_key": "property/6767906449166432/019d02c9-9886-701e-bfea-5f4ff74b96ed.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "Community Tour | Social Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=CwZw17rTLtj"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199dfc1-7549-706b-90d8-eeab7c199df4",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-elevation-auto",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-elevation-flagstaff-az",
      "search_query": "pet-friendly apartments Flagstaff AZ",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Flagstaff, AZ",
      "h2_subtitle": "Explore Elevation's pet-friendly apartments in Flagstaff. Your furry friend will love our spacious layouts and community amenities.",
      "page_copy": "Finding a home that accommodates both you and your furry family member is crucial, and Elevation in Flagstaff, AZ meets that need beautifully. Our pet-friendly apartments offer expansive spaces, perfect for pets of all sizes to roam comfortably. Plus, with flexible lease options and stylish features like island kitchens and elegant lighting, every resident can enjoy a convenient and luxurious lifestyle.\n\nAt Elevation, not only will you enjoy the added storage solutions and outdoor kitchen with a gas BBQ grill, but your pet will appreciate the pet-friendly environment. Situated in scenic Flagstaff, AZ, our community provides ample space for walks, play, and relaxation, making it a perfect spot for pet owners. Experience the best of Flagstaff's pet-friendly living at Elevation!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Flagstaff, AZ",
      "seo_description": "Discover Elevation's pet-friendly apartments in Flagstaff, AZ. Enjoy convenient living with your pet, featuring flexible leases and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "in-unit-washer-dryer-apartments-elevation-flagstaff",
      "search_query": "apartments with in-unit washer dryer Flagstaff",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Washers in Flagstaff",
      "h2_subtitle": "Discover apartments with in-unit washer and dryers at Elevation. Enjoy ultimate convenience in Flagstaff with our modern and stylish homes.",
      "page_copy": "At Elevation in Flagstaff, experience the luxury of apartments equipped with in-unit washers and dryers. Say goodbye to trips to communal laundry facilities and hello to laundry at your convenience, right in the comfort of your home. Nestled in Flagstaff, AZ, our community blends modern amenities with cozy living spaces.\n\nIn addition to the in-unit washers and dryers, Elevation offers flexible lease terms, perfect for tailoring your living experience. Enjoy features such as island kitchens, elegant lighting, and outdoor cooking options with our gas BBQ grills. Every aspect of our Flagstaff community is designed to enhance your living situation and maximize convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Washer Dryer Apartments in Flagstaff",
      "seo_description": "Find Flagstaff apartments with in-unit washers and dryers at Elevation, offering ultimate convenience and modern amenities just for you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "dedicated-parking-apartments-elevation-flagstaff",
      "search_query": "Flagstaff apartments with dedicated parking",
      "category": "Amenity",
      "h1_title": "Flagstaff Apartments with Dedicated Parking",
      "h2_subtitle": "Find dedicated parking at Elevation in Flagstaff. Enjoy easy access and hassle-free living with our premier parking solutions.",
      "page_copy": "At Elevation, located in the heart of Flagstaff, AZ, enjoy the convenience and peace of mind that comes with having dedicated parking. Our apartment community offers residents exclusive parking spaces, ensuring you experience easy accessibility and protection for your vehicle.\n\nElevation not only provides reliable parking but also a suite of premium amenities like flexible lease terms, elegant island kitchens, and additional storage options. Enjoy the scenic beauty of Flagstaff knowing your car is always ready and waiting. With amenities such as outdoor kitchens with gas BBQ grills, Elevation combines functional living with a vibrant community in Flagstaff.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Flagstaff Apartments with Dedicated Parking",
      "seo_description": "Discover dedicated parking at Elevation, Flagstaff. Enjoy easy accessibility with your apartment's convenient parking solutions and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "pool-apartments-elevation-flagstaff",
      "search_query": "Flagstaff apartments with a pool",
      "category": "Amenity",
      "h1_title": "Flagstaff Apartments with a Pool",
      "h2_subtitle": "Dive into luxury at Elevation, where Flagstaff apartments offer a refreshing pool. Enjoy relaxation and fun just steps from your home.",
      "page_copy": "Experience the ultimate in relaxation and recreation at Elevation, where our Flagstaff apartments boast a pristine pool as part of our comprehensive amenity package. Perfect for cooling off on warm Arizona days or just unwinding, our pool offers residents a tranquil escape within the community.\n\nBesides enjoying a refreshing swim, residents can take advantage of flexible lease options and convenient features like island kitchens and additional storage. Located in Flagstaff, AZ, Elevation combines comfort and style, offering not only a premier poolside experience but also elegant lighting and outdoor kitchen facilities with gas BBQ grills. Live the life of leisure and convenience right here in Flagstaff.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Flagstaff Apartments with a Pool",
      "seo_description": "Enjoy life with a poolside lifestyle at Elevation's Flagstaff apartments. Dive into luxury and enjoy premium amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "air-conditioning-apartments-elevation-flagstaff-86004",
      "search_query": "apartments with air conditioning Flagstaff 86004",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Flagstaff",
      "h2_subtitle": "Stay cool in Flagstaff's 86004 area with Elevation apartments featuring air conditioning. Experience comfort year-round with modern amenities.",
      "page_copy": "Elevation offers Flagstaff residents the ultimate in comfort with apartments equipped with air conditioning right in the 86004 area. Beat the Arizona heat with our state-of-the-art cooling systems, ensuring a pleasant living environment all year long. Nestled conveniently in Flagstaff, our homes are designed with your perfect climate in mind.\n\nBeyond air conditioning, Elevation provides additional luxurious amenities such as flexible lease terms to suit your lifestyle, stylish island kitchens, and outdoor kitchen spaces with gas BBQ grills. Enhance your living experience with ample storage and elegantly lit interiors. Discover why our Flagstaff community is the perfect blend of comfort and style in the heart of the 86004 area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments in Flagstaff 86004",
      "seo_description": "Stay comfortable at Elevation apartments in Flagstaff 86004 with air conditioning and premium amenities in a premier location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-elevation-flagstaff-az",
      "search_query": "one bedroom apartments Flagstaff AZ",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Flagstaff, AZ",
      "h2_subtitle": "Discover the charm of one bedroom apartments at Elevation in Flagstaff, AZ. Experience modern living with a range of amenities.",
      "page_copy": "Elevation offers stylish one bedroom apartments in the vibrant city of Flagstaff, AZ. Perfect for singles or couples, our one bedroom units provide a cozy, intimate setting with all the modern conveniences you desire. Each apartment is thoughtfully designed to maximize space and comfort, ensuring you feel right at home.\n\nResidents at Elevation enjoy a variety of amenities, including flexible lease options and beautifully crafted island kitchens. Additional storage is available, making it easy to keep your space neat and organized. Plus, our outdoor kitchen with a gas BBQ grill and elegant lighting fixtures add a touch of luxury to your daily life. Elevation is the perfect place to call home in Flagstaff, AZ.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Flagstaff, AZ",
      "seo_description": "Find your perfect one bedroom apartment at Elevation, Flagstaff, AZ. Enjoy modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "two-bedroom-rentals-elevation-coconino-county",
      "search_query": "two bedroom rentals in Coconino County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Rentals in Coconino County",
      "h2_subtitle": "Explore spacious two bedroom rentals at Elevation, located in the heart of Coconino County. Perfect for comfort and convenience.",
      "page_copy": "Elevation is proud to offer spacious two bedroom rentals nestled within the scenic surroundings of Coconino County. These well-appointed units are ideal for families, roommates, or anyone needing extra space in a vibrant community. Experience the perfect blend of comfort and modern living in our thoughtfully designed apartments.\n\nEach two bedroom rental comes with access to excellent amenities, such as flexible lease terms and island kitchens, ensuring a convenient and hassle-free lifestyle. With elegant lighting and ample storage options, residents find peace of mind in our secure and welcoming environment. Plus, enjoy socializing at our outdoor kitchen with a gas BBQ grill. Elevation is your answer for exceptional two bedroom rentals in Coconino County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Rentals in Coconino County",
      "seo_description": "Find spacious two bedroom rentals at Elevation, located in the vibrant Coconino County. Enjoy modern amenities and a welcoming atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "three-bedroom-floorplans-elevation-86004",
      "search_query": "three bedroom floorplans near 86004",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Floorplans near 86004",
      "h2_subtitle": "Discover spacious three bedroom floorplans at Elevation, conveniently located near 86004. Ideal for families or shared living.",
      "page_copy": "At Elevation, we offer expansive three bedroom floorplans designed to meet the diverse needs of our residents, all in close proximity to the 86004 area. Our layouts provide plenty of room for family living or sharing with roommates, ensuring everyone has their own personal space within a warm community.\n\nThese floorplans come with modern amenities that elevate your living experience, such as flexible lease options, an exquisite island kitchen, and luxurious lighting fixtures. Additional storage solutions add to the functionality and ease of living. Whether you're entertaining at our outdoor kitchen with a gas BBQ grill or relaxing in your spacious home, Elevation provides the ideal environment for living life your way near the 86004 area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Floorplans near 86004",
      "seo_description": "Discover spacious three bedroom floorplans at Elevation, near 86004. Ideal for modern living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "apartments-elevation-near-nau-flagstaff",
      "search_query": "apartments near northern arizona university flagstaff",
      "category": "School",
      "h1_title": "Apartments Near Northern Arizona University",
      "h2_subtitle": "Explore exceptional living at Elevation, offering convenient apartments near Northern Arizona University in Flagstaff.",
      "page_copy": "Elevation is the perfect choice for those seeking apartments near Northern Arizona University in Flagstaff. Situated in a prime location, our community provides easy access to campus life while enjoying the comfort and luxury of home. Whether you're a student, faculty, or staff, our apartments accommodate a variety of lifestyles.\n\nIn addition to our prime location, residents enjoy an array of amenities including flexible lease options, an elegant island kitchen, and beautiful lighting designs. Additional storage is available for those who need it, and our outdoor kitchen with a gas BBQ grill is perfect for social gatherings. At Elevation, experience superior apartment living just a stone's throw from Northern Arizona University.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Northern Arizona University",
      "seo_description": "Live comfortably at Elevation, offering apartments near Northern Arizona University, Flagstaff with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "apartments-close-to-coconino-community-college",
      "search_query": "apartments close to coconino community college az",
      "category": "School",
      "h1_title": "Apartments Close to Coconino Community College",
      "h2_subtitle": "Find convenient living at Elevation, offering modern apartments close to Coconino Community College in AZ.",
      "page_copy": "For those seeking a vibrant community, Elevation provides top-tier apartments close to Coconino Community College in AZ. Perfectly located for students and staff, our community offers easy access to the college, complemented by the comfort and convenience of home.\n\nResidents at Elevation enjoy superb amenities, including flexible lease terms, a stylish island kitchen, and elegant lighting. Additional storage is available to ensure a clutter-free living experience, while our outdoor kitchen with a gas BBQ grill provides a great space for socializing. Discover a new standard of apartment living close to Coconino Community College at Elevation.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Coconino Community College",
      "seo_description": "Experience modern living at Elevation, offering apartments near Coconino Community College in AZ with exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "student-housing-near-sbs-nau-elevation",
      "search_query": "student housing near college of social and behavioral sciences nau",
      "category": "School",
      "h1_title": "Student Housing Near College of SBS NAU",
      "h2_subtitle": "Discover ideal student housing close to the College of Social and Behavioral Sciences at NAU, with Elevation's convenient offerings.",
      "page_copy": "Elevation offers excellent student housing options near the College of Social and Behavioral Sciences at Northern Arizona University. Our community is designed for students seeking a balance between academics and leisure, providing easy access to the college and a range of nearby amenities.\n\nOur student housing includes modern conveniences like flexible lease plans, a chic island kitchen, and tasteful lighting to enhance your living environment. Ample storage solutions and an outdoor kitchen featuring a gas BBQ grill make Elevation a prime choice for students desiring convenience and comfort. Experience student living at its finest near the College of Social and Behavioral Sciences at NAU.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Student Housing Near College of SBS NAU",
      "seo_description": "Find convenient student housing at Elevation, near the College of Social and Behavioral Sciences NAU, offering modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "apartments-near-nau-health-learning-center",
      "search_query": "apartments close to nau health and learning center flagstaff az",
      "category": "Hospital",
      "h1_title": "Apartments Close to NAU Health & Learning Center",
      "h2_subtitle": "Live comfortably at Elevation, offering apartments close to the NAU Health and Learning Center in Flagstaff, AZ.",
      "page_copy": "Living at Elevation, you'll find apartments conveniently located close to the NAU Health and Learning Center in Flagstaff, AZ. Our community provides students and university staff with an ideal living situation that combines proximity to campus resources with the comforts of well-appointed apartment living.\n\nOur residents benefit from seamless access to NAU's Health and Learning Center, while enjoying amenities such as flexible leasing options, a stunning island kitchen, and tasteful, elegant lighting throughout. Additional storage and a welcoming outdoor kitchen with a gas BBQ grill enrich our offerings, making Elevation the ideal home base for those connected with Northern Arizona University.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to NAU Health & Learning Center",
      "seo_description": "Elevation offers apartments near the NAU Health and Learning Center in Flagstaff, AZ, with modern amenities and flexible leases.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "apartments-near-flagstaff-va-clinic",
      "search_query": "apartments near flagstaff va clinic coconino county",
      "category": "Hospital",
      "h1_title": "Apartments Near Flagstaff VA Clinic",
      "h2_subtitle": "Explore convenient living at Elevation, offering apartments near the Flagstaff VA Clinic in Coconino County.",
      "page_copy": "Elevation presents a unique opportunity for residents looking to reside near the Flagstaff VA Clinic in Coconino County. With a strategic location, our apartments are ideally suited for veterans and healthcare professionals seeking a comfortable and accessible home environment.\n\nAt Elevation, you will experience premium living with features like flexible lease options, sophisticated island kitchens, and stylish lighting. Our community also offers added storage and a spacious outdoor kitchen equipped with a gas BBQ grill. Choose Elevation for a harmonious blend of convenience and luxury close to the Flagstaff VA Clinic.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Flagstaff VA Clinic",
      "seo_description": "Find your home at Elevation, offering apartments near the Flagstaff VA Clinic in Coconino County, with great amenities and flexible leases.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "apartments-near-walnut-canyon-national-monument",
      "search_query": "apartments near Walnut Canyon National Monument Flagstaff",
      "category": "Park",
      "h1_title": "Apartments Near Walnut Canyon National Monument",
      "h2_subtitle": "Discover Elevation, an ideal choice for apartments near Walnut Canyon National Monument, bringing nature and comfort together.",
      "page_copy": "At Elevation, enjoy living in apartments that offer close proximity to Walnut Canyon National Monument in Flagstaff. Ideal for nature enthusiasts and adventure seekers, our community provides easy access to scenic trails and natural wonders while also offering a comfortable, modern living environment.\n\nResidents can take advantage of our flexible lease terms, chic island kitchens, and warm, elegant lighting in each apartment. With the added benefits of additional storage and an outdoor kitchen complete with a gas BBQ grill, Elevation offers a perfect blend of outdoor exploration and home comforts. Choose us for an apartment experience that’s as inspiring as it is convenient.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Walnut Canyon National Monument",
      "seo_description": "Elevation offers modern apartments near Walnut Canyon National Monument in Flagstaff, combining outdoor access with upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "apartments-near-buffalo-park-flagstaff",
      "search_query": "Buffalo Park Flagstaff AZ apartments",
      "category": "Park",
      "h1_title": "Buffalo Park Flagstaff AZ Apartments",
      "h2_subtitle": "Experience the natural beauty of Buffalo Park with Elevation, offering quality apartments in Flagstaff, AZ.",
      "page_copy": "Elevation provides an excellent living option for those seeking apartments near Buffalo Park in Flagstaff, AZ. Our community is perfect for those who love the outdoors, offering easy access to the park’s scenic trails and breathtaking vistas.\n\nAt Elevation, you’ll find an array of amenities that enhance your living experience, including flexible lease terms, stunning island kitchens, and elegant lighting fixtures. Additional storage options and a delightful outdoor kitchen with a gas BBQ grill make our community an ideal choice for enjoying both nature and modern comforts. Come and discover all that Elevation has to offer near Buffalo Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Buffalo Park Flagstaff AZ Apartments",
      "seo_description": "Discover Elevation, offering apartments near Buffalo Park in Flagstaff, AZ, with picturesque surroundings and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "apartments-near-thorpe-park-coconino-county",
      "search_query": "Thorpe Park Coconino County nearby apartments",
      "category": "Park",
      "h1_title": "Thorpe Park Coconino County Nearby Apartments",
      "h2_subtitle": "Find the perfect home at Elevation, located near Thorpe Park in Coconino County, offering comfort and convenience.",
      "page_copy": "Choose Elevation for your next home if you’re searching for apartments near Thorpe Park in Coconino County. Our community offers a perfect balance of peaceful park proximity and contemporary living conveniences, ideal for active individuals and families alike.\n\nResidents at Elevation enjoy features such as flexible leasing options, chic island-style kitchens, and refined lighting designs, ensuring a comfortable living experience. You’ll also find extra storage and an inviting outdoor kitchen equipped with a gas BBQ grill, allowing you to enjoy the beautiful Colorado landscape right at your doorstep. Make Elevation your new home near Thorpe Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Thorpe Park Coconino County Nearby Apartments",
      "seo_description": "Explore Elevation, offering modern apartments near Thorpe Park in Coconino County with great amenities and scenic access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166432",
      "source": "generator",
      "page_item_url": "apartments-near-bushmaster-park-flagstaff",
      "search_query": "Bushmaster Park apartments Flagstaff AZ",
      "category": "Park",
      "h1_title": "Bushmaster Park Apartments Flagstaff AZ",
      "h2_subtitle": "Enjoy convenient living at Elevation, near Bushmaster Park in Flagstaff, AZ, where community and comfort meet.",
      "page_copy": "For those looking for apartments near Bushmaster Park in Flagstaff, AZ, Elevation offers a perfect blend of convenience and style. Our apartments provide a great location for enjoying Bushmaster Park’s family-friendly amenities and community activities.\n\nAt Elevation, every apartment is designed with features like elegant island kitchens, tasteful lighting fixtures, and flexible leases to suit your lifestyle. Additional storage spaces ensure you have room for all your belongings, and the outdoor kitchen with a gas BBQ grill makes it easy to host friends and family amidst the natural beauty of Flagstaff. Choose Elevation for a vibrant lifestyle near Bushmaster Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bushmaster Park Apartments Flagstaff AZ",
      "seo_description": "Discover Elevation, offering stylish apartments near Bushmaster Park in Flagstaff, AZ, with convenient access to local amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5302"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425359"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=8d53df2115f119eb60112aed695c2fe093994552cf6f525691046d51e7a2d8b4388dcdf5c010bf782b6b166262b9fa40\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T4HH5RRH"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "96ELF"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8878162707"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "BR573712000"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Elevation/scheduletourwidget/u1w2NWOY1bmxNEVuMn/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImNmc2J5aHIzYWs4ak9qTS9zTVNtakE9PSIsInZhbHVlIjoidlJCWDJ6bkVJRTFsN2tud00xVmx0dz09IiwibWFjIjoiMmU0ZGU5ZjMxN2JmMzViOTRmOTkwNTZjMmZjZWRkZjNhZTJiZDM5NTAwMzY2NzQ4YWZhMjAyZGJkYTgxMmI2ZSJ9"
    }
  ],
  "custom_qb_id": "5302",
  "custom_repli_id": "18104425359",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=8d53df2115f119eb60112aed695c2fe093994552cf6f525691046d51e7a2d8b4388dcdf5c010bf782b6b166262b9fa40\"></script>",
  "custom_google_gtm_id": "GTM-T4HH5RRH",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "96ELF",
  "custom_hubspot_company_id": "8878162707",
  "custom_broker_license_number": "BR573712000",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Elevation/scheduletourwidget/u1w2NWOY1bmxNEVuMn/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImNmc2J5aHIzYWs4ak9qTS9zTVNtakE9PSIsInZhbHVlIjoidlJCWDJ6bkVJRTFsN2tud00xVmx0dz09IiwibWFjIjoiMmU0ZGU5ZjMxN2JmMzViOTRmOTkwNTZjMmZjZWRkZjNhZTJiZDM5NTAwMzY2NzQ4YWZhMjAyZGJkYTgxMmI2ZSJ9",
  "custom_audioeye_site_id": "27db924c-9fc7-4b90-8307-9ba5015ba2af",
  "custom_audioeye_site_hash": "0c03bda9135d71e6b695af4f2dbc1c6a"
};

export const generatedAt = '2026-08-21T22:01:02.300Z';
